import { render, staticRenderFns } from "./DataPresentationSmall-Ex.vue?vue&type=template&id=220b31db&scoped=true&"
import script from "./DataPresentationSmall-Ex.vue?vue&type=script&lang=js&"
export * from "./DataPresentationSmall-Ex.vue?vue&type=script&lang=js&"
import style0 from "./DataPresentationSmall-Ex.vue?vue&type=style&index=0&id=220b31db&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220b31db",
  null
  
)

export default component.exports